import { render, staticRenderFns } from "./ResumoTerminalDetalhado.vue?vue&type=template&id=18550ddc&scoped=true"
import script from "./ResumoTerminalDetalhado.vue?vue&type=script&lang=js"
export * from "./ResumoTerminalDetalhado.vue?vue&type=script&lang=js"
import style0 from "./ResumoTerminalDetalhado.vue?vue&type=style&index=0&id=18550ddc&prod&lang=css"
import style1 from "./ResumoTerminalDetalhado.vue?vue&type=style&index=1&id=18550ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18550ddc",
  null
  
)

export default component.exports